import {useCallback,useMemo} from 'react'
import {useSearchParams} from 'react-router-dom'
import {TIME_BUCKETS} from '../../lib/championships.js'
import {scopeWorklistRows} from '../command-center/useWorklistScope.js'
import {campaignPeriodsApply} from './campaignViewState.js'
import {readWorkPeriods,writeWorkPeriods} from './campaignNavigation.js'
export default function useCampaignWorklistScope(items,view,now,sharedBoard=false){
 const [params,setParams]=useSearchParams(),key=params.get('periods')
 const active=useMemo(()=>readWorkPeriods(new URLSearchParams(key===null?'':`periods=${encodeURIComponent(key)}`)),[key])
 const setActive=useCallback(update=>setParams(previous=>writeWorkPeriods(previous,update)),[setParams])
 const scoped=campaignPeriodsApply(view,sharedBoard)
 const rows=useMemo(()=>scoped?scopeWorklistRows(items,active,now):items,[items,scoped,active,now])
 const label=scoped?`Worklist periods: ${TIME_BUCKETS.filter(bucket=>active.has(bucket.key)).map(bucket=>bucket.label).join(', ')||'none'}. Past periods use held date; future periods use effective date. Hidden periods are excluded, including previously checked rows.`:''
 return {active,setActive,rows,label}
}
